<template>
    <div class="py-2">
        <div v-if="collapsible"
            class="form-header relative cursor-pointer p-3 text-center relative"
            :class="is_open
                ? 'bg-blue-100 hover:bg-blue-200'
                : 'bg-gray-warm-200 hover:bg-gray-warm-300'
            "
            @click="toggleOpen"
        >
            <div class="deal-wrap relative">
                <h2 class="text-lg xs:text-xl font-semibold pt-1 px-6 select-none"
                    :class="is_open ? 'text-blue-700' : 'text-gray-900'"
                    v-html="$t(section)"
                ></h2>

                <div class="absolute right-0 top-0 px-1 pt-px">
                    <i :class="is_open ? 'fas fa-caret-up text-blue-700' : 'fas fa-caret-down text-gray-900'"></i>
                </div>
            </div>
        </div>

        <div
            v-show-slide:150:ease-in-out="is_open"
            ref="accordion"
            @slide-open-end="slideOpenEnd"
            @slide-close-start="slideCloseStart"
            class="px-4 sm:px-8 bg-gray-warm-100 accordion"
            :class="collapsible ? 'pt-0' : 'pt-3'"
        >
            <form
                :id="name"
                class="form pb-6"
                :class="className"
            >
                <input type="hidden" name="_method" :value="method" />

                <slot />

                <form-submit
                    v-if="include_footer && ! read_only"
                    :id="name"
                    :method="method"
                    :url="url"
                    :include_discard_button="include_discard_button"
                    @saved="handleSaved"
                />
            </form>
        </div>
    </div>
</template>

<script>
import FormSubmit from './form-submit.vue';

export default {
    components: {
        FormSubmit,
    },

    props: {
        className: {},
        closed: { default: true },
        method: {},
        name: {},
        section: {},
        url: {},
        read_only: { default: false },
        collapsible: { default: true },
        include_footer: { default: true },
        include_discard_button: { default: true },
    },

    data() {
        return {
            is_open: ! this.collapsible || ! this.closed,
        }
    },

    methods: {
        toggleOpen() {
            this.is_open = ! this.is_open;
        },
        slideCloseStart() {
            this.$refs.accordion.style.overflow = 'hidden';
        },
        slideOpenEnd() {
            this.$refs.accordion.style.overflow = 'visible';

            const qs = new URLSearchParams(window.location.search);
            const field = qs.get('field');

            if (qs.get('section') == this.name && field) {
                const section_heading = document.getElementById(field);

                if (section_heading) {
                    section_heading.setAttribute('tabindex', '-1');
                    section_heading.focus();
                }
            }
        },
        handleSaved(responseData) {
            this.$emit('saved', responseData);
        },
    },

    mounted() {
        const qs = new URLSearchParams(window.location.search);

        if (qs.get('section') == this.name) {
            this.is_open = true;
        }
    },
}
</script>
